module.exports = __webpack_public_path__ + "img/equatorial-guinea.c04b6ff3.svg";